<template>
	<div>
		<!-- <b-button v-b-modal.modal-prevent-closing>Open Modal</b-button> -->

			<!-- :title="getText('form_title')"
			:ok-title="getText('accept')" -->
		<b-modal
			id="modal-prevent-closing"
			ref="modal"
			size="lg"
			centered
			no-close-on-esc
			no-close-on-backdrop
			hide-header-close
			ok-only
			@show="resetModal"
			@hidden="resetModal"
			@ok="handleOk"
		>
			<!-- Terms and conditions -->
			<div>
				<div class="overflow-auto p-3" style="height: 25em; box-shadow: inset 0px 0px 8px rgba(0,0,0,0.1)">
					<div class="overflow-auto" v-html="getText('product_terms_and_conditions')"></div>
				</div>
			</div>

			<!-- <hr> -->

			<!-- Age and gender form -->
			<!-- <b-form ref="form" @submit.stop.prevent="handleSubmit" class="row">
				<b-form-group
					class="col"
					:label="getText('form_age')"
					label-for="age-input"
					:state="ageState"
				>
					<b-form-select
						id="age-input"
						class="form-select"
						v-model="age"
						:options="ageOptions"
						:state="ageState"
						required
					></b-form-select>
				</b-form-group>

				<b-form-group
					class="col"
					:label="getText('form_gender')"
					label-for="gender-input"
					:state="genderState"
				>
					<b-form-select
						class="form-select"
						id="gender-input"
						v-model="gender"
						:options="genderOptions"
						:state="genderState"
						required
					></b-form-select>
				</b-form-group>
			</b-form> -->
		</b-modal>
	</div>
</template>



<script>
	export default {
		data() {
			return {
				// age: null,
				// ageState: null,
				// gender: null,
				// genderState: null,

				// ageOptions: [],
				// genderOptions: [
					// { value: null, text: this.getText("form_select"), disabled: true },
					// { value: "male", text: this.getText("form_gender_male") },
					// { value: "female", text: this.getText("form_gender_female") },
					// { value: "other", text: this.getText("form_gender_other") },
					// { value: 'unspecified', text: 'Prefer not to say' }
				// ],
			}
		},
		mounted() {
			// this.ageOptions.push({
			// 	value: "12-",
			// 	text: this.getText("form_age_12")
			// });
			// for (var i = 13; i <= 17; i++) {
			// 	this.ageOptions.push({
			// 		value: i.toString(),
			// 		text: i.toString()
			// 	});
			// }
			// this.ageOptions.push({
			// 	value: "18+",
			// 	text: this.getText("form_age_18")
			// });
		},
		methods: {
			open() {
				this.$refs.modal.show();
			},
			checkFormValidity() {
				// const valid = this.$refs.form.checkValidity();
				// this.ageState = !!this.age;
				// this.genderState = !!this.gender;
				// return valid;
				return true;
			},
			resetModal() {
				// this.age = null;
				// this.ageState = null;
				// this.gender = null;
				// this.genderState = null;
			},
			handleOk(bvModalEvent) {
				// Prevent modal from closing
				bvModalEvent.preventDefault()
				// Trigger submit handler
				this.handleSubmit()
			},
			handleSubmit() {
				if (!this.checkFormValidity()) { return; }

				this.$emit("submit", {
					// age: this.age,
					// gender: this.gender
				});

				this.$nextTick(() => {
					this.$bvModal.hide('modal-prevent-closing')
				})
			}
		}
	}
</script>



<style scoped>
</style>
